import { Tax, TaxRegion } from '../entity'

export const findTaxByRegion = ({ taxes, region }: { taxes: Tax[]; region: Pick<TaxRegion, 'name' | 'currency'> }) =>
  !!taxes?.length
    ? taxes.find((tax) => tax.region.name === region.name && tax.region.currency === region.currency)
    : ({} as Tax)
